// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Tax_invalidDataError__Bi+NC"};